import { useCallback, useEffect } from "react";
import { HMSNoiseSuppressionPlugin } from "@100mslive/hms-noise-suppression";
import {
  selectIsLocalAudioPluginPresent,
  selectLocalPeer,
  useHMSStore,
} from "@100mslive/react-sdk";
import { hmsActions, hmsStore } from "../hms";
import { useSetAppDataByKey } from "../components/AppData/useUISettings";
import { APP_DATA } from "../common/constants";

export const useNoiseSuppression = isCheckDependence => {
  // const hmsActions = useHMSActions();

  const [isNoiseSuppressedState, setIsNoiseSuppressedState] =
    useSetAppDataByKey(APP_DATA.noiseSuppression);

  const localPeer = useHMSStore(selectLocalPeer);

  useEffect(() => {
    window.localStorage.setItem(
      "noiseSuppressionPlugin",
      isNoiseSuppressedState
    );
  }, [isNoiseSuppressedState]);

  const handleNoiseSuppression = useCallback(async () => {
    if (!localPeer?.audioTrack) return;

    const durationInMs = 80;
    const noiseSuppressionPlugin = new HMSNoiseSuppressionPlugin(durationInMs);
    const pluginSupport = hmsActions.validateAudioPluginSupport(
      noiseSuppressionPlugin
    );
    const isNoiseSuppressed = hmsStore.getState(
      selectIsLocalAudioPluginPresent(noiseSuppressionPlugin?.getName())
    );

    try {
      if (pluginSupport?.isSupported) {
        // console.log("Plugin is supported");
        if (!isNoiseSuppressed && isNoiseSuppressedState) {
          // add background noise suppression
          await hmsActions.addPluginToAudioTrack(noiseSuppressionPlugin);
        } else if (isNoiseSuppressed && !isNoiseSuppressedState) {
          // remove background noise suppression
          await hmsActions.removePluginFromAudioTrack(noiseSuppressionPlugin);
        }
        noiseSuppressionPlugin?.setEnabled(isNoiseSuppressedState);
      } else {
        const err = pluginSupport?.errMsg;
        console.error(err);
      }
    } catch (error) {
      console.log("noise suppression failure - ", isNoiseSuppressed, error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localPeer?.audioTrack, isCheckDependence ? isNoiseSuppressedState : ""]);

  // useEffect(() => {
  //   handleNoiseSuppression();
  // }, [handleNoiseSuppression]);

  return [
    isNoiseSuppressedState,
    setIsNoiseSuppressedState,
    handleNoiseSuppression,
  ];
};
